import User from '../user/class';

class Memo {
  constructor(data) {
    this._id = data._id;
    this.content = data.content;
    this.createdAt = data.createdAt;
    this.event = data.event;
    this.project = data.project;
    this.goal = data.goal;
    this.workspace = data.workspace;
    this.user = new User(data.user);

    // Set thanksReceivedFrom to empty array, if missing
    // due to the fact in the beginning there was no thanksReceivedFrom attribute.
    // So all existing memos don't really have it.
    this.thanksReceivedFrom = data.thanksReceivedFrom || [];
  }
}

export default Memo;



// WEBPACK FOOTER //
// ./src/memos/class.js